/* Brand assets. URLs are resolved by Vite at build time, but each can be
   overridden at mount time (e.g. for white-labelling) via setResources(). */
import logoUrl from "./assets/logo.svg";
import mascotUrl from "./assets/mascot.svg";

/* A tenant's own artwork, when the deployment serves more than one brand.
   The shipped mark and mascot belong to THIS deployment's brand, so a tenant
   that has not supplied its own gets NEITHER rather than someone else's
   character on its application form — a wrong mascot is worse than no mascot.
   Both surfaces below already degrade to a clean monogram / no illustration. */
import { RUNTIME_BRAND as RUNTIME } from "./runtimeBrand.js";

export const resources = RUNTIME
  ? { logo: RUNTIME.logoUrl || null, mascot: RUNTIME.mascotUrl || null }
  : { logo: logoUrl, mascot: mascotUrl };

export function setResources(next) {
  if (next) Object.assign(resources, next);
}
